import React, { Component } from 'react'
import Portal from 'components/Portal/Portal';
import onClickOutside from 'react-onclickoutside'
import FocusTrap from 'focus-trap-react'
import './FloatingMenu.scss'

export default class FloatingMenu extends Component {
  constructor(props){
    super(props)
    this.state = {
      animation: props.animationDirection === 'right' ? 'materialZoomInRight' : 'materialZoomIn',
      closing: false
    }
  }
  componentWillReceiveProps = nextProps => {
    if(this.props.isOpen === false && nextProps.isOpen === true){
      this.setState({
        animation: nextProps.animationDirection === 'right' ? 'materialZoomInRight' : 'materialZoomIn',
        closing: false
      })
    }
  }
  requestClose = () => {
    this.setState({
      animation: this.props.animationDirection === 'right' ? 'materialZoomOutRight' : 'materialZoomOut',
      closing: true
    })
  }
  // getLeftValue = el => {
  //   const pageWidth = window.innerWidth || document.body.clientWidth;
  //   const leftPlusWidth = el.left + el.width;
  //   console.log(pageWidth, leftPlusWidth);
  //   if(leftPlusWidth > pageWidth){
  //     return el - (leftPlusWidth - pageWidth)
  //   }
  //   return el.left
  // }
	render() {
		const { options = [], alignTo, align, alignScreenRight, isOpen, onRequestClose, className, offsetTop=0, offsetRight=0 } = this.props;
    const alignElement = alignTo ? alignTo.getBoundingClientRect() : null;
    const menuStyle = alignElement ? {
      left: alignScreenRight ? 'auto' : align === "right" ? alignElement.right - alignElement.width : alignElement.left,
      right: alignScreenRight ? 0 + offsetRight : 'auto',
      top: alignElement.top + offsetTop
    } : {}
		return (
      <Portal isOpened={isOpen}>
      	<MenuBody
      		animation={this.state.animation}
      		options={options}
          className={className}
      		menuStyle={menuStyle}
      		requestClose={this.requestClose}
          onMenuClosed={onRequestClose}
          closing={this.state.closing}
      	/>
      </Portal>
    )
	}
}

class MenuBody extends Component{
  state = {
    activeItemIndex: 0
  }
  handleClickOutside = () => {
    this.props.requestClose()
  }
  handleAnimationEnd = () => {
    if(this.props.closing){
      this.props.onMenuClosed()
    }
  }
  onItemClick = option => {
    if(option.onClick){
      option.onClick(option)
    }
    this.props.requestClose()
  }
  unfocusAll = () => {
    if(document.activeElement.tagName === 'BUTTON'){
      document.activeElement.blur()
    }
  }
  handleKeyDown = e => {
    if(e.keyCode === 27){
      this.props.requestClose();
    }
    else if(e.keyCode === 38){
      if(this.state.activeItemIndex > 0){
        this.setState(state => ({
          activeItemIndex: state.activeItemIndex - 1
        }), () => {
          const focusable = document.getElementById(`floating-menu-index-${this.state.activeItemIndex}`)
          if(focusable){
            focusable.focus();
          }
        })
      }
    }
    else if(e.keyCode === 40){
      if(this.state.activeItemIndex < this.props.options.length - 1){
        this.setState(state => ({
          activeItemIndex: state.activeItemIndex + 1
        }), () => {
          const focusable = document.getElementById(`floating-menu-index-${this.state.activeItemIndex}`)
          if(focusable){
            focusable.focus();
          }
        })
      }
    }
  }
  render(){
    const{ menuStyle, options, animation, className='' } = this.props;
    return(
      <FocusTrap
        focusTrapOptions={{clickOutsideDeactivates: true}}
        className={`floating-menu ${animation} ${className}`}
        onAnimationEnd={this.handleAnimationEnd}
        style={menuStyle}
        onKeyDown={this.handleKeyDown}
        role="menu"
        aria-activedescendant={`floating-menu-index-${this.state.activeItemIndex}`}
      >
        {options.map((option, i) => (
          <MenuItem
            {...option}
            onMouseEnter={this.unfocusAll}
            onClick={() => {
              this.onItemClick(option)
            }}
            index={i}
            key={i}
          />
        ))}
      </FocusTrap>
    )
  }
}
MenuBody = onClickOutside(MenuBody)

const MenuItem = ({ label = '', onClick, onMouseEnter, href, target, index }) => (
  href ?
  <a className="menu-item" href={href} onMouseEnter={onMouseEnter} target={target} id={`floating-menu-index-${index}`} role="menuitem">
    {label}
  </a>
  :
  <button className="menu-item" onClick={onClick} onMouseEnter={onMouseEnter} id={`floating-menu-index-${index}`} role="menuitem">
		{label}
	</button>
)



// WEBPACK FOOTER //
// ./src/components/FloatingMenu/FloatingMenu.js